const DealsDisclaimer = () => {
  return (
    <div data-testid="deals-disclaimer" className="mt-xxl pt-xs">
      <div className="font-bold text-xs mb-xs">Disclaimer</div>
      <p className="text-xs pb-lg">
        Subject to participating retailer’s product availability, deals are for
        Leafly Pickup and Delivery Reservations only. Not valid for cash or cash
        equivalent. Participating retailers own all choices related to the deal,
        content, and its administration. Deals may be extended, modified, or
        discontinued at any time without notice. Leafly operates in compliance
        with all applicable laws regarding access to cannabis. You must be 21+
        or a registered patient for eligibility. Enjoy responsibly.
      </p>
      <p className="text-xs pb-xs">
        Promotions: While supplies last. Not valid for cash or cash equivalent.
        Participating retailers own all choices related to the promotion,
        content, and its administration. Promotions may be extended, modified,
        or discontinued at any time without notice. Leafly operates in
        compliance with all applicable laws regarding access to cannabis. You
        must be 21+ or a registered patient for eligibility. Enjoy responsibly.
      </p>
    </div>
  );
};

export default DealsDisclaimer;
